import { Box } from '@material-ui/core';
import { AIProductMatchBadge, SText } from '@setvi/shared/components';
import { TextColor } from '@setvi/shared/enums';
import { distances } from '@setvi/shared/styles';

interface AdditionalContentProps {
  percentage: number;
  prefix?: string;
  text: string;
}
const contentHeight = 55;
const margin = 12;
export const additionalContentHeight = contentHeight + 2 * margin;

export const AdditionalContent = ({
  percentage,
  prefix,
  text
}: AdditionalContentProps) => (
  <Box
    height={contentHeight}
    display="flex"
    alignItems="center"
    width="100%"
    style={{ borderTop: '1px solid #E0E0E0' }}
    py={margin}
    px={distances.px.base}>
    <Box
      style={{
        gridGap: 24,
        display: 'flex',
        alignItems: 'start'
      }}>
      <AIProductMatchBadge value={percentage} fontSize={12} />

      {!!text && (
        <Box py="2px">
          <SText
            fontColor={TextColor.SlateGrey}
            prefix={
              !!prefix && (
                <b
                  style={{
                    color: '#20262D',
                    marginRight: 4
                  }}>
                  {prefix}
                </b>
              )
            }
            size="sm"
            maxLines={2}
            lineHeight="20px"
            title={text}>
            {text}
          </SText>
        </Box>
      )}
    </Box>
  </Box>
);
